import React from 'react';
import { Row, Col, Card, CardBody, CardTitle, CardText, CardImg } from 'reactstrap';
import { motion } from 'framer-motion';

function ViewerTestimonials() {
  const youtubeVideos = [
    {
      title: 'LuluLovely Hot Ones',
      videoLink: 'https://www.youtube.com/watch?v=bQUNoQlCxzM',
      imgSrc: [
        {
          imgSrc: './comment1.png',
          altText: 'Positive comment 1',
        },
        {
          imgSrc: './comment2.png',
          altText: 'Positive comment 2',
        },
        {
          imgSrc: './comment3.png',
          altText: 'Positive comment 3',
        },
        {
          imgSrc: './comment4.png',
          altText: 'Positive comment 4',
        },
      ],
    },
    {
      title: 'Overwatch 2 Rage Compilation',
      videoLink: 'https://www.youtube.com/watch?v=meb6S4PtRGc',
      imgSrc: [
        {
          imgSrc: './comment5.png',
          altText: 'Positive comment 5',
        },
        {
          imgSrc: './comment6.png',
          altText: 'Positive comment 6',
        },
        {
          imgSrc: './comment7.png',
          altText: 'Positive comment 7',
        },
        {
          imgSrc: './comment8.png',
          altText: 'Positive comment 8',
        },
      ],
    },
  ];

  const videoVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };

  return (
    //add breakpoints for mobile responsiveness
    <Row xs="1" sm="2">
      {youtubeVideos.map((video, index) => (
        <Col key={index} className="mb-4">
          <motion.div initial="hidden" animate="visible" variants={videoVariants}>
            <Card>
              <CardBody>
                <CardTitle tag="h5">{video.title}</CardTitle>
                <div className="video-responsive">
                  <iframe width="100%" height="315" src={video.videoLink} frameBorder="0" allowfullscreen title={video.title}></iframe>
                </div>
                <CardText>
                  <motion.div whileHover={{ scale: 1.05 }}>
                    {video.imgSrc.map((img, index) => (
                      <CardImg src={img.imgSrc} alt={img.altText} key={index} />
                    ))}
                  </motion.div>
                </CardText>
              </CardBody>
            </Card>
          </motion.div>
        </Col>
      ))}
    </Row>
  );
}

export default ViewerTestimonials;
